// Import base components
import http, { httpV2 } from "../http.js";

const AnnouncementsService = {
  dismissAnnouncement: (user_id, announcement_id) =>
    httpV2.put(`/announcements/dismiss`, { user_id, announcement_id }),
};

export default AnnouncementsService;
